import { useRef } from 'react';

import { Button } from 'components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'components/ui/dialog';

type DiscardChangesDialogProps = {
  isOpen: boolean;
  sectionLabel: string;
  onKeepEditing: () => void;
  onDiscard: () => void;
};

/**
 * Studio has no AlertDialog primitive, so this is the shadcn Dialog with the alertdialog role.
 * "Keep editing" takes focus so Enter never throws work away.
 */
export function DiscardChangesDialog({ isOpen, sectionLabel, onKeepEditing, onDiscard }: DiscardChangesDialogProps) {
  const keepEditingRef = useRef<HTMLButtonElement>(null);

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onKeepEditing()}>
      <DialogContent
        role="alertdialog"
        className="max-w-md"
        onOpenAutoFocus={(event) => {
          event.preventDefault();
          keepEditingRef.current?.focus();
        }}
      >
        <DialogHeader>
          <DialogTitle>Discard changes?</DialogTitle>
          <DialogDescription>Your changes on {sectionLabel} aren&apos;t saved yet.</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button ref={keepEditingRef} variant="outline" onClick={onKeepEditing}>
            Keep editing
          </Button>
          <Button variant="destructive" onClick={onDiscard}>
            Discard
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
